import axios from "../api/axios";
import { BASE_URL } from "../constants/apiConstants";
import {
  HOME_PAGE_CONTENT_API,
  ABOUT_PAGE_CONTENT_API,
  FEATURES_PAGE_CONTENT_API,
  BLOG_API,
} from "./endpoints";

const getImageLink = (path) => {
  return `${BASE_URL}${path}`
};

export const getHomePageContent = async () => {
  const response = await axios.get(HOME_PAGE_CONTENT_API);
  const data = response.data;

  const pageContent = {
    section1Title: data.section1_title,
    section1Description: data.section1_description,
    section1Image: getImageLink(data.section1_image),

    section2Title: data.section2_title,
    section2Description: data.section2_description,
    section2Image: getImageLink(data.section2_image),

    section3Title: data.section3_title,
    section3Description: data.section3_description,
    section3Image: getImageLink(data.section3_image),

    section4Title: data.section4_title,
    section4Description: data.section4_description,
    
    section5Title: data.section5_title,
    section5Card1Icon: getImageLink(data.section5_card1_icon),
    section5Card1Title: data.section5_card1_title,
    section5Card1Description: data.section5_card1_description,

    section5Card2Icon: getImageLink(data.section5_card2_icon),
    section5Card2Title: data.section5_card2_title,
    section5Card2Description: data.section5_card2_description,

    section5Card3Icon: getImageLink(data.section5_card3_icon),
    section5Card3Title: data.section5_card3_title,
    section5Card3Description: data.section5_card3_description,

    section5Card4Icon: getImageLink(data.section5_card4_icon),
    section5Card4Title: data.section5_card4_title,
    section5Card4Description: data.section5_card4_description,
  }
  return pageContent;
};

export const getAboutPageContent = async () => {
  const response = await axios.get(ABOUT_PAGE_CONTENT_API);
  const data = response.data;

  const pageContent = {
    section1Title: data.section1_title,
    section1Description: data.section1_description,

    section2Title: data.section2_title,

    section2Card1Icon: getImageLink(data.section2_card1_icon),
    section2Card1Title: data.section2_card1_title,

    section2Card2Icon: getImageLink(data.section2_card2_icon),
    section2Card2Title: data.section2_card2_title,

    section2Card3Icon: getImageLink(data.section2_card3_icon),
    section2Card3Title: data.section2_card3_title,

    section2Card4Icon: getImageLink(data.section2_card4_icon),
    section2Card4Title: data.section2_card4_title,

    section2Card5Icon: getImageLink(data.section2_card5_icon),
    section2Card5Title: data.section2_card5_title,

    section2Card6Icon: getImageLink(data.section2_card6_icon),
    section2Card6Title: data.section2_card6_title,

    section3Title: data.section3_title,
    section3Description: data.section3_description,
  }
  return pageContent;
};

export const getFeaturesPageContent = async () => {
  const response = await axios.get(FEATURES_PAGE_CONTENT_API);
  const data = response.data;

  const pageContent = {
    section1Title: data.section1_title,
    section1Description: data.section1_description,
    section1Image: getImageLink(data.section1_image),

    section2Title: data.section2_title,
    section2Description: data.section2_description,

    section2Card1Title: data.section2_card1_title,
    section2Card1Description: data.section2_card1_description,

    section2Card2Title: data.section2_card2_title,
    section2Card2Description: data.section2_card2_description,

    section2Card3Title: data.section2_card3_title,
    section2Card3Description: data.section2_card3_description,

    section2Card4Title: data.section2_card4_title,
    section2Card4Description: data.section2_card4_description,

    section2Card5Title: data.section2_card5_title,
    section2Card5Description: data.section2_card5_description,

    section2Card6Title: data.section2_card6_title,
    section2Card6Description: data.section2_card6_description,

    section2Card7Title: data.section2_card7_title,
    section2Card7Description: data.section2_card7_description,

    section2Card8Title: data.section2_card8_title,
    section2Card8Description: data.section2_card8_description,
  }
  return pageContent;
};

export const blogPostAPI = async (slug) => {
  const response = await axios.get(`${BLOG_API}${slug}/`);
  return response;
};

export const blogsAPI = async (page, page_size, blog_type = null) => {
  let url = `${BLOG_API}?page=${page}&page_size=${page_size}`;
  if (blog_type) {
    url += `&blog_type=${blog_type}`;
  }
  const response = await axios.get(url);
  return response;
};
